module.exports = __webpack_public_path__ + "img/guidelines-02.e51ea5bd.png";